export const dropPageSlice = set => ({
  activePage: 0,
  setActivePage: activePage => set(() => ({ activePage })),
})
